var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hover-card" }, [
    _c("div", { staticClass: "hover-card-content" }, [
      _c("h3", [_vm._v(_vm._s(_vm.item.title))]),
      _vm._v(" "),
      _c("div", { staticClass: "product-description" }, [
        _vm._v("\n      " + _vm._s(_vm.item.abstract) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "learn-more" },
        [
          _c(
            "router-link",
            {
              staticClass: "product-link",
              attrs: { to: _vm.item.path, tag: "a" },
            },
            [_vm._v("\n        Learn More\n      ")]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "hover-card-action-group" },
      [
        _c("HighlightButton", {
          class: _vm.stockManagedClass,
          attrs: {
            disabled: _vm.outOfStock,
            title: _vm.stockManagedText,
            "button-type": "pill",
            "button-style": "solid",
            "button-size": "small",
          },
          on: { clicked: _vm.addToCartLinkClicked },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }